module.exports = __webpack_public_path__ + "src/assets/at.2f67122d.png";